import React from 'react';

const Error = ({ message }) => {
  return <span style={{ color: 'red', fontSize: '0.8rem', marginTop: '2px', marginBottom: '5px' }}>{message}</span>;
};

export default Error;
